<template>
<div>
  <!-- <vx-card> -->
    <!-- <div class="vx-row">    -->
      <!-- <div class="vx-col w-full"> -->
        <div :class="isRunning || finished ? 'text-center sentence text-danger' : 'text-center sentence text-primary'">{{displayTime}}</div>
      <!-- </div>  -->
    <!-- </div> -->
  <!-- </vx-card> -->
</div>
</template>

<script>

export default {
  components: {
    
  },
  // props: {
  //   title: String,
  //   chipColor: String
  // },
  data () {
    return {
      time: 0,
      timer: 0,
      isRunning: false,
      finished: false
    }
  },
  computed: {
    displayTime () {
      const min = this.time / 60
      const second =  this.time % 60
      return `${this.padLeft(parseInt(min), 2)}:${this.padLeft(parseInt(second), 2)}`
    }
  },
  methods: {
    padLeft (nr, n, str) {
      return Array(n - String(nr).length + 1).join(str || '0') + nr
    },
    start () {
      this.isRunning = true
      this.timer =  setInterval(function () {
        this.time++
      }.bind(this), 1000)
    },
    stop () {
      this.isRunning = false
      this.finished = true
      clearInterval(this.timer)
    },
    reset () {
      this.isRunning = false
      this.finished = false
      clearInterval(this.timer)
      this.time = 0
      
    }
  },
  created () {
    
  }
}

</script>
